import { isCollection, Map as Map$1 } from 'immutable';
import { debounceTime } from 'rxjs/operators';
import { NgRedux } from '@angular-redux/store';
import { Injectable, Input, Directive, NgModule, forwardRef, Host, Inject, Optional, Self, SkipSelf, TemplateRef, ViewContainerRef } from '@angular/core';
import { FormArray, FormControl, FormGroup, NgControl, NgForm, ControlContainer, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NgModelGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular-redux/store';
import * as ɵngcc2 from '@angular/forms';
const composeReducers = (...reducers) => (s, action) => reducers.reduce((st, reducer) => reducer(st, action), s);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FORM_CHANGED = '@@angular-redux/form/FORM_CHANGED';
class FormStore {
    /// NOTE(cbond): The declaration of store is misleading. This class is
    /// actually capable of taking a plain Redux store or an NgRedux instance.
    /// But in order to make the ng dependency injector work properly, we
    /// declare it as an NgRedux type, since the @angular-redux/store use case involves
    /// calling the constructor of this class manually (from configure.ts),
    /// where a plain store can be cast to an NgRedux. (For our purposes, they
    /// have almost identical shapes.)
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * @return {?}
     */
    getState() {
        return this.store.getState();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    subscribe(fn) {
        return this.store.subscribe(() => fn(this.getState()));
    }
    /**
     * @template T
     * @param {?} path
     * @param {?} form
     * @param {?} value
     * @return {?}
     */
    valueChanged(path, form, value) {
        this.store.dispatch({
            type: FORM_CHANGED,
            payload: {
                path,
                form,
                valid: form.valid === true,
                value,
            },
        });
    }
}
FormStore.ɵfac = function FormStore_Factory(t) { return new (t || FormStore)(ɵngcc0.ɵɵinject(ɵngcc1.NgRedux)); };
FormStore.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FormStore, factory: FormStore.ɵfac });
/** @nocollapse */
FormStore.ctorParameters = () => [
    { type: NgRedux }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormStore, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.NgRedux }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormException extends Error {
    /**
     * @param {?} msg
     */
    constructor(msg) {
        super(msg);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class State {
    /**
     * @template StateType
     * @param {?} state
     * @param {?} path
     * @param {?=} fn
     * @return {?}
     */
    static traverse(state, path, fn) {
        /** @type {?} */
        let deepValue = state;
        for (const k of path) {
            /** @type {?} */
            const parent = deepValue;
            if (isCollection(deepValue)) {
                /** @type {?} */
                const m = (/** @type {?} */ (((/** @type {?} */ (deepValue)))));
                if (typeof m.get === 'function') {
                    deepValue = m.get(k);
                }
                else {
                    throw new FormException(`Cannot retrieve value from immutable nonassociative container: ${k}`);
                }
            }
            else if (deepValue instanceof Map) {
                deepValue = ((/** @type {?} */ (((/** @type {?} */ (deepValue)))))).get(k);
            }
            else {
                deepValue = ((/** @type {?} */ (deepValue)))[k];
            }
            if (typeof fn === 'function') {
                /** @type {?} */
                const transformed = fn(parent, k, path.slice(path.indexOf(k) + 1), deepValue);
                deepValue = transformed[k];
                Object.assign(parent, transformed);
            }
            // If we were not able to find this state inside of our root state
            // structure, then we return undefined -- not null -- to indicate that
            // state. But this could be a perfectly normal use-case so we don't
            // want to throw an exception or anything along those lines.
            if (deepValue === undefined) {
                return undefined;
            }
        }
        return deepValue;
    }
    /**
     * @template StateType
     * @param {?} state
     * @param {?} path
     * @return {?}
     */
    static get(state, path) {
        return State.traverse(state, path);
    }
    /**
     * @template StateType
     * @param {?} state
     * @param {?} path
     * @param {?=} value
     * @return {?}
     */
    static assign(state, path, value) {
        /** @type {?} */
        const operations = State.inspect(state);
        if (path.length === 0) {
            return operations.update(null, value);
        }
        /** @type {?} */
        const root = operations.clone();
        // We want to shallow clone the object, and then trace a path to the place
        // we want to update, cloning each object we traversed on our way and then
        // finally updating the value on the last parent to be @value. This seems
        // to offer the best performance: we can shallow clone everything that has
        // not been modified, and {deep clone + update} the path down to the value
        // that we wish to update.
        State.traverse(root, path, (parent, key, remainingPath, innerValue) => {
            /** @type {?} */
            const parentOperations = State.inspect(parent);
            if (innerValue) {
                /** @type {?} */
                const innerOperations = State.inspect(innerValue);
                return parentOperations.update(key, remainingPath.length > 0
                    ? innerOperations.clone()
                    : innerOperations.merge(null, value));
            }
            else {
                /** @type {?} */
                const getProbableType = (stateKey) => {
                    // NOTE(cbond): If your code gets here, you might not be using the library
                    /// correctly. If you are assigning into a path in your state, try to
                    /// ensure that there is a path to traverse, even if everything is just
                    /// empty objects and arrays. If we have to guess the type of the containers
                    /// and then create them ourselves, we may not get the types right. Use
                    /// the Redux `initial state' construct to resolve this issue if you like.
                    return typeof stateKey === 'number'
                        ? new Array()
                        : Array.isArray(stateKey)
                            ? Map$1()
                            : new Object();
                };
                return parentOperations.update(key, remainingPath.length > 0
                    ? getProbableType(remainingPath[0])
                    : value);
            }
        });
        return root;
    }
    /**
     * @template K
     * @param {?} object
     * @return {?}
     */
    static inspect(object) {
        /** @type {?} */
        const metaOperations = (
        // TODO: Write proper type declarations for following Function types
        update, merge, clone) => {
            /** @type {?} */
            const operations = {
                /// Clone the object (shallow)
                clone: typeof clone === 'function'
                    ? () => (/** @type {?} */ (clone((/** @type {?} */ (object)))))
                    : () => object,
                /// Update a specific key inside of the container object
                update: (key, value) => update(operations.clone(), key, value),
                /// Merge existing values with new values
                merge: (key, value) => {
                    /** @type {?} */
                    const cloned = operations.clone();
                    return merge(cloned, key, value, (v) => update(cloned, key, v));
                },
            };
            return operations;
        };
        if (isCollection(object)) {
            return metaOperations(
            // Replace
            (parent, key, value) => {
                if (key != null) {
                    return parent.set(key, value);
                }
                else {
                    return value;
                }
            }, 
            // Merge
            (parent, key, value) => {
                if (key) {
                    return parent.mergeDeepIn(Array.isArray(key) ? key : [key], value);
                }
                else {
                    if (Map$1.isMap(value)) {
                        return parent.mergeDeep(value);
                    }
                    else {
                        return parent.concat(value);
                    }
                }
            });
        }
        else if (Array.isArray(object)) {
            return metaOperations(
            // Replace array contents
            (parent, key, value) => {
                if (key != null) {
                    parent[key] = value;
                }
                else {
                    parent.splice.apply(parent, [0, parent.length].concat(Array.isArray(value) ? value : [value]));
                }
            }, 
            // Merge
            (parent, _, value, setter) => {
                setter(parent.concat(value));
                return parent;
            }, 
            // Clone
            () => Array.prototype.slice.call(object, 0));
        }
        else if (object instanceof Map) {
            return metaOperations(
            // Update map key
            (parent, key, value) => {
                if (key != null) {
                    return parent.set(key, value);
                }
                else {
                    /** @type {?} */
                    const m = new Map((/** @type {?} */ (value)));
                    parent.clear();
                    m.forEach((mapValue, index) => parent.set(index, mapValue));
                    return parent;
                }
            }, 
            // Merge
            (parent, _, value) => {
                /** @type {?} */
                const m = new Map((/** @type {?} */ (value)));
                m.forEach((mapValue, key) => parent.set(key, mapValue));
                return parent;
            }, 
            // Clone
            () => object instanceof WeakMap
                ? new WeakMap((/** @type {?} */ (object)))
                : new Map((/** @type {?} */ (object))));
        }
        else if (object instanceof WeakSet || object instanceof Set) {
            return metaOperations(
            // Update element at index in set
            (parent, key, value) => {
                if (key != null) {
                    return parent.set(key, value);
                }
                else {
                    /** @type {?} */
                    const s = new Set((/** @type {?} */ (value)));
                    s.forEach((setValue, index) => parent.set(index, setValue));
                    s.clear();
                    return parent;
                }
            }, 
            // Merge
            (parent, _, value) => {
                for (const element of value) {
                    parent.add(element);
                }
                return parent;
            }, 
            // Clone
            () => object instanceof WeakSet
                ? new WeakSet((/** @type {?} */ (object)))
                : new Set((/** @type {?} */ (object))));
        }
        else if (object instanceof Date) {
            throw new FormException('Cannot understand why a Date object appears in the mutation path!');
        }
        else {
            switch (typeof object) {
                case 'boolean':
                case 'function':
                case 'number':
                case 'string':
                case 'symbol':
                case 'undefined':
                    break;
                case 'object':
                    if (object == null) {
                        break;
                    }
                    return metaOperations((parent, key, value) => {
                        if (key != null) {
                            return Object.assign({}, parent, { [key]: value });
                        }
                        return Object.assign({}, parent, ((/** @type {?} */ (value))));
                    }, (parent, _, value) => {
                        for (const k of Object.keys(value)) {
                            parent[k] = ((/** @type {?} */ (value)))[k];
                        }
                        return parent;
                    }, () => (Object.assign({}, ((/** @type {?} */ (object))))));
                default:
                    break;
            }
        }
        throw new Error(`An object of type ${typeof object} has appeared in the mutation path! Every element ` +
            'in the mutation path should be an array, an associative container, or a set');
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static empty(value) {
        return (value == null ||
            (value.length === 0 ||
                (typeof value.length === 'undefined' &&
                    Object.keys(value).length === 0)));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const defaultFormReducer = (initialState) => {
    /** @type {?} */
    const reducer = (state = initialState, action) => {
        switch (action.type) {
            case FORM_CHANGED:
                return State.assign(state, action.payload.path, action.payload.value);
            default:
                return state;
        }
    };
    return reducer;
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/// Use this function in your providers list if you are not using @angular-redux/core.
/// This will allow you to provide a preexisting store that you have already
/// configured, rather than letting @angular-redux/core create one for you.
/** @type {?} */
const provideReduxForms = (store) => {
    /** @type {?} */
    const abstractStore = wrap(store);
    return [
        { provide: FormStore, useValue: new FormStore((/** @type {?} */ (abstractStore))) },
    ];
};
/** @type {?} */
const wrap = (store) => {
    /** @type {?} */
    const dispatch = (action) => store.dispatch(action);
    /** @type {?} */
    const getState = () => (/** @type {?} */ (store.getState()));
    /** @type {?} */
    const subscribe = (fn) => store.subscribe(() => fn(store.getState()));
    return { dispatch, getState, subscribe };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConnectBase {
    /**
     * @return {?}
     */
    get path() {
        /** @type {?} */
        const path = typeof this.connect === 'function' ? this.connect() : this.connect;
        switch (typeof path) {
            case 'object':
                if (State.empty(path)) {
                    return [];
                }
                if (Array.isArray(path)) {
                    return (/** @type {?} */ (path));
                }
            case 'string':
                return ((/** @type {?} */ (path))).split(/\./g);
            default:
                // fallthrough above (no break)
                throw new Error(`Cannot determine path to object: ${JSON.stringify(path)}`);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.formSubscription) {
            this.formSubscription.unsubscribe();
        }
        if (typeof this.stateSubscription === 'function') {
            this.stateSubscription(); // unsubscribe
        }
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        Promise.resolve().then(() => {
            this.resetState();
            if (this.store) {
                this.stateSubscription = this.store.subscribe(() => this.resetState());
            }
            Promise.resolve().then(() => {
                this.formSubscription = ((/** @type {?} */ (this.form.valueChanges)))
                    .pipe(debounceTime(0))
                    .subscribe((values) => this.publish(values));
            });
        });
    }
    /**
     * @private
     * @param {?} path
     * @param {?} formElement
     * @return {?}
     */
    descendants(path, formElement) {
        /** @type {?} */
        const pairs = new Array();
        if (formElement instanceof FormArray) {
            formElement.controls.forEach((c, index) => {
                for (const d of this.descendants(((/** @type {?} */ (path))).concat([index]), c)) {
                    pairs.push(d);
                }
            });
        }
        else if (formElement instanceof FormGroup) {
            for (const k of Object.keys(formElement.controls)) {
                pairs.push({
                    path: path.concat([k]),
                    control: formElement.controls[k],
                });
            }
        }
        else if (formElement instanceof NgControl ||
            formElement instanceof FormControl) {
            return [{ path, control: (/** @type {?} */ (formElement)) }];
        }
        else {
            throw new Error(`Unknown type of form element: ${formElement.constructor.name}`);
        }
        return pairs.filter(p => {
            /** @type {?} */
            const parent = ((/** @type {?} */ (p.control)))._parent;
            return parent === this.form.control || parent === this.form;
        });
    }
    /**
     * @private
     * @return {?}
     */
    resetState() {
        /** @type {?} */
        const formElement = this.form.control === undefined ? this.form : this.form.control;
        /** @type {?} */
        const children = this.descendants([], formElement);
        children.forEach(c => {
            const { path, control } = c;
            /** @type {?} */
            const value = State.get(this.getState(), this.path.concat(path));
            if (control.value !== value) {
                control.setValue(value);
            }
        });
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    publish(value) {
        if (this.store) {
            this.store.valueChanged(this.path, this.form, value);
        }
    }
    /**
     * @private
     * @return {?}
     */
    getState() {
        if (this.store) {
            return this.store.getState();
        }
    }
}
ConnectBase.ɵfac = function ConnectBase_Factory(t) { return new (t || ConnectBase)(); };
ConnectBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ConnectBase, inputs: { connect: "connect" } });
ConnectBase.propDecorators = {
    connect: [{ type: Input }]
};


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// For reactive forms (without implicit NgForm)
class ReactiveConnectDirective extends ConnectBase {
    /**
     * @param {?} store
     */
    constructor(store) {
        super();
        this.store = store;
    }
}
ReactiveConnectDirective.ɵfac = function ReactiveConnectDirective_Factory(t) { return new (t || ReactiveConnectDirective)(ɵngcc0.ɵɵdirectiveInject(FormStore)); };
ReactiveConnectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ReactiveConnectDirective, selectors: [["form", "connect", "", "formGroup", ""]], inputs: { formGroup: "formGroup" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
ReactiveConnectDirective.ctorParameters = () => [
    { type: FormStore }
];
ReactiveConnectDirective.propDecorators = {
    formGroup: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReactiveConnectDirective, [{
        type: Directive,
        args: [{ selector: 'form[connect][formGroup]' }]
    }], function () { return [{ type: FormStore }]; }, { formGroup: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// For template forms (with implicit NgForm)
class ConnectDirective extends ConnectBase {
    /**
     * @param {?} store
     * @param {?} form
     */
    constructor(store, form) {
        super();
        this.store = store;
        this.form = form;
    }
}
ConnectDirective.ɵfac = function ConnectDirective_Factory(t) { return new (t || ConnectDirective)(ɵngcc0.ɵɵdirectiveInject(FormStore), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgForm)); };
ConnectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ConnectDirective, selectors: [["form", "connect", "", 3, "formGroup", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
ConnectDirective.ctorParameters = () => [
    { type: FormStore },
    { type: NgForm }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConnectDirective, [{
        type: Directive,
        args: [{ selector: 'form[connect]:not([formGroup])' }]
    }], function () { return [{ type: FormStore }, { type: ɵngcc2.NgForm }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const declarations = [ConnectDirective, ReactiveConnectDirective];
class NgReduxFormConnectModule {
}
NgReduxFormConnectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgReduxFormConnectModule });
NgReduxFormConnectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgReduxFormConnectModule_Factory(t) { return new (t || NgReduxFormConnectModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgReduxFormConnectModule, { declarations: [ConnectDirective, ReactiveConnectDirective], exports: [ConnectDirective, ReactiveConnectDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgReduxFormConnectModule, [{
        type: NgModule,
        args: [{
                declarations: [...declarations],
                exports: [...declarations]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConnectArrayTemplate {
    /**
     * @param {?} $implicit
     * @param {?} index
     * @param {?} item
     */
    constructor($implicit, index, item) {
        this.$implicit = $implicit;
        this.index = index;
        this.item = item;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return [...(parent.path || []), name];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConnectArrayDirective extends ControlContainer {
    /**
     * @param {?} parent
     * @param {?} rawValidators
     * @param {?} rawAsyncValidators
     * @param {?} connection
     * @param {?} templateRef
     * @param {?} viewContainerRef
     * @param {?} store
     */
    constructor(parent, rawValidators, rawAsyncValidators, connection, templateRef, viewContainerRef, store) {
        super();
        this.parent = parent;
        this.rawValidators = rawValidators;
        this.rawAsyncValidators = rawAsyncValidators;
        this.connection = connection;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.store = store;
        this.array = new FormArray([]);
        this.stateSubscription = this.store.subscribe(state => this.resetState(state));
        this.registerInternals(this.array);
    }
    /**
     * @param {?} collection
     * @return {?}
     */
    set connectArrayOf(collection) {
        this.key = collection;
        this.resetState(this.store.getState());
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.formDirective.addControl((/** @type {?} */ (this)));
    }
    /**
     * @return {?}
     */
    get name() {
        return this.key || '';
    }
    /**
     * @return {?}
     */
    get control() {
        return this.array;
    }
    /**
     * @return {?}
     */
    get formDirective() {
        return (/** @type {?} */ (this.parent.formDirective));
    }
    /**
     * @return {?}
     */
    get path() {
        return this.key ? controlPath(this.key, this.parent) : [];
    }
    /**
     * @return {?}
     */
    get validator() {
        return Validators.compose(this.rawValidators);
    }
    /**
     * @return {?}
     */
    get asyncValidator() {
        return Validators.composeAsync(this.rawAsyncValidators);
    }
    /**
     * @return {?}
     */
    updateValueAndValidity() {
        // stub?
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.viewContainerRef.clear();
        if (this.key) {
            this.formDirective.form.removeControl(this.key);
        }
        this.stateSubscription();
    }
    /**
     * @private
     * @param {?} state
     * @return {?}
     */
    resetState(state) {
        if (this.key == null || this.key.length === 0) {
            return; // no state to retreive if no key is set
        }
        /** @type {?} */
        const iterable = State.get(state, this.connection.path.concat(this.path));
        /** @type {?} */
        let index = 0;
        for (const value of iterable) {
            /** @type {?} */
            const viewRef = this.viewContainerRef.length > index
                ? ((/** @type {?} */ (this.viewContainerRef.get(index))))
                : null;
            if (viewRef == null) {
                /** @type {?} */
                const embeddedViewRef = this.viewContainerRef.createEmbeddedView(this.templateRef, new ConnectArrayTemplate(index, index, value), index);
                this.patchDescendantControls(embeddedViewRef);
                this.array.insert(index, this.transform(this.array, embeddedViewRef.context.item));
            }
            else {
                Object.assign(viewRef.context, new ConnectArrayTemplate(index, index, value));
            }
            ++index;
        }
        while (this.viewContainerRef.length > index) {
            this.viewContainerRef.remove(this.viewContainerRef.length - 1);
        }
    }
    /**
     * @private
     * @param {?} array
     * @return {?}
     */
    registerInternals(array) {
        array.registerControl = () => undefined;
        array.registerOnChange = () => undefined;
        Object.defineProperties(this, {
            _rawValidators: {
                value: this.rawValidators || [],
            },
            _rawAsyncValidators: {
                value: this.rawAsyncValidators || [],
            },
        });
    }
    /**
     * @private
     * @param {?} viewRef
     * @return {?}
     */
    patchDescendantControls(viewRef) {
        /** @type {?} */
        const groups = Object.keys(viewRef._view)
            .map(k => viewRef._view[k])
            .filter(c => c instanceof NgModelGroup);
        groups.forEach(c => {
            Object.defineProperties(c, {
                _parent: {
                    value: this,
                },
                _checkParentType: {
                    value: () => undefined,
                },
            });
        });
    }
    /**
     * @private
     * @param {?} parent
     * @param {?} reference
     * @return {?}
     */
    transform(parent, reference) {
        /** @type {?} */
        const emptyControl = () => {
            /** @type {?} */
            const control = new FormControl(null);
            control.setParent(parent);
            return control;
        };
        if (reference == null) {
            return emptyControl();
        }
        if (typeof reference.toJS === 'function') {
            reference = reference.toJS();
        }
        switch (typeof reference) {
            case 'string':
            case 'number':
            case 'boolean':
                return emptyControl();
        }
        /** @type {?} */
        const iterate = (iterable) => {
            /** @type {?} */
            const array = new FormArray([]);
            this.registerInternals(array);
            for (let i = array.length; i > 0; i--) {
                array.removeAt(i);
            }
            for (const value of iterable) {
                /** @type {?} */
                const transformed = this.transform(array, value);
                if (transformed) {
                    array.push(transformed);
                }
            }
            return array;
        };
        /** @type {?} */
        const associate = (value) => {
            /** @type {?} */
            const group = new FormGroup({});
            group.setParent(parent);
            for (const key of Object.keys(value)) {
                /** @type {?} */
                const transformed = this.transform(group, value[key]);
                if (transformed) {
                    group.addControl(key, transformed);
                }
            }
            return group;
        };
        if (Array.isArray(reference)) {
            return iterate((/** @type {?} */ (reference)));
        }
        else if (reference instanceof Set) {
            return iterate((/** @type {?} */ (reference)));
        }
        else if (reference instanceof Map) {
            return associate((/** @type {?} */ (reference)));
        }
        else if (reference instanceof Object) {
            return associate(reference);
        }
        else {
            throw new Error(`Cannot convert object of type ${typeof reference} / ${reference.toString()} to form element`);
        }
    }
}
ConnectArrayDirective.ɵfac = function ConnectArrayDirective_Factory(t) { return new (t || ConnectArrayDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ControlContainer, 13), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 10), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 10), ɵngcc0.ɵɵdirectiveInject(ConnectBase), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(FormStore)); };
ConnectArrayDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ConnectArrayDirective, selectors: [["", "connectArray", ""]], inputs: { connectArrayOf: "connectArrayOf" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: ControlContainer,
                useExisting: forwardRef(() => ConnectArrayDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
ConnectArrayDirective.ctorParameters = () => [
    { type: ControlContainer, decorators: [{ type: Optional }, { type: Host }, { type: SkipSelf }] },
    { type: Array, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ConnectBase },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: FormStore }
];
ConnectArrayDirective.propDecorators = {
    connectArrayOf: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConnectArrayDirective, [{
        type: Directive,
        args: [{
                selector: '[connectArray]',
                providers: [
                    {
                        provide: ControlContainer,
                        useExisting: forwardRef(() => ConnectArrayDirective)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc2.ControlContainer, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ConnectBase }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: FormStore }]; }, { connectArrayOf: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const declarations$1 = [ConnectArrayDirective];
class NgReduxFormConnectArrayModule {
}
NgReduxFormConnectArrayModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgReduxFormConnectArrayModule });
NgReduxFormConnectArrayModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgReduxFormConnectArrayModule_Factory(t) { return new (t || NgReduxFormConnectArrayModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgReduxFormConnectArrayModule, { declarations: [ConnectArrayDirective], exports: [ConnectArrayDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgReduxFormConnectArrayModule, [{
        type: NgModule,
        args: [{
                declarations: [...declarations$1],
                exports: [...declarations$1]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} ngRedux
 * @return {?}
 */
function formStoreFactory(ngRedux) {
    return new FormStore(ngRedux);
}
class NgReduxFormModule {
}
NgReduxFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgReduxFormModule });
NgReduxFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgReduxFormModule_Factory(t) { return new (t || NgReduxFormModule)(); }, providers: [
        {
            provide: FormStore,
            useFactory: formStoreFactory,
            deps: [NgRedux]
        },
    ], imports: [[
            FormsModule,
            ReactiveFormsModule,
            NgReduxFormConnectModule,
            NgReduxFormConnectArrayModule,
        ], NgReduxFormConnectModule, NgReduxFormConnectArrayModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgReduxFormModule, { imports: function () { return [FormsModule,
        ReactiveFormsModule, NgReduxFormConnectModule, NgReduxFormConnectArrayModule]; }, exports: function () { return [NgReduxFormConnectModule, NgReduxFormConnectArrayModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgReduxFormModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    NgReduxFormConnectModule,
                    NgReduxFormConnectArrayModule,
                ],
                exports: [NgReduxFormConnectModule, NgReduxFormConnectArrayModule],
                providers: [
                    {
                        provide: FormStore,
                        useFactory: formStoreFactory,
                        deps: [NgRedux]
                    },
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { composeReducers, defaultFormReducer, FormException, FORM_CHANGED, FormStore, provideReduxForms, ConnectBase, ReactiveConnectDirective, ConnectDirective, NgReduxFormConnectModule, ConnectArrayTemplate, ConnectArrayDirective, NgReduxFormConnectArrayModule, formStoreFactory, NgReduxFormModule };

//# sourceMappingURL=angular-redux-form.js.map